import { css, FlattenSimpleInterpolation } from 'styled-components';

import { IBorderRadiusData } from './calcBorderRadiusStyles';

export const calcBorderRadiusMediaShortHand = (query: IBorderRadiusData) => {
  const {
    topLeft,
    topRight,
    bottomLeft,
    bottomRight,
  } = query;

  const styles: FlattenSimpleInterpolation[] = [];

  if (topLeft) {
    styles.push(css`
      border-top-left-radius: ${topLeft};
    `);
  }

  if (topRight) {
    styles.push(css`
      border-top-right-radius: ${topRight};
    `);
  }

  if (bottomRight) {
    styles.push(css`
      border-bottom-right-radius: ${bottomRight};
    `);
  }

  if (bottomLeft) {
    styles.push(css`
      border-bottom-left-radius: ${bottomLeft};
    `);
  }

  return styles;
};
